import React from 'react';
import { Alert, Divider, Group, NumberInput, PasswordInput, Select, Stack, Switch, Text, Textarea, TextInput } from '@mantine/core';
import { IconCalendar, IconLock, IconShieldCheck } from '@tabler/icons-react';

export default function ShareOptions({ form, setForm, settings, errors }) {
  const update = (name, value) => setForm((prev) => ({ ...prev, [name]: value }));
  const expiryOptions = [1, 3, 7, 14, 30]
    .filter((days) => days <= settings.maxDays)
    .map((days) => ({ value: String(days), label: `${days} gün` }));
  expiryOptions.push({ value: 'custom', label: 'Özel tarih' });
  const maxCustom = new Date(Date.now() + settings.maxDays * 86_400_000).toISOString().slice(0, 10);
  const minCustom = new Date(Date.now() + 86_400_000).toISOString().slice(0, 10);
  return <Stack gap="lg">
    <TextInput label="Paylaşım başlığı" description="Paylaşım listesinde görünecek ad" placeholder="Örn. Proje dokümanları" value={form.title} onChange={(e) => update('title', e.currentTarget.value)} maxLength={100}/>
    <Textarea label="Açıklama (isteğe bağlı)" placeholder="Dosyalarla ilgili kısa bir not..." minRows={2} maxRows={4} autosize value={form.note} onChange={(e) => update('note', e.currentTarget.value)} maxLength={500}/>
    <Divider label="BAĞLANTI AYARLARI" labelPosition="left"/>
    <Select label="Geçerlilik süresi" description="Bağlantı bu süre sonunda otomatik kapanır." leftSection={<IconCalendar size={17}/>} data={expiryOptions} value={form.days} onChange={(value) => update('days', value || '7')} allowDeselect={false}/>
    {form.days === 'custom' && <TextInput type="date" label="Son erişim tarihi" min={minCustom} max={maxCustom} value={form.customDate} onChange={(e) => update('customDate', e.currentTarget.value)} error={errors.customDate}/>}
    <div className="fs-security-setting">
      <Group justify="space-between" align="center" wrap="nowrap" gap="sm">
        <Group align="flex-start" gap="sm" wrap="nowrap">
          <div className="fs-option-icon"><IconLock size={20}/></div>
          <div>
            <Text size="sm" fw={700}>Şifreyle koru</Text>
            <Text size="xs" c="dimmed" mt={3}>Bağlantıyı açan kişiye indirme öncesinde şifre sorulur.</Text>
          </div>
        </Group>
        <Switch
          size="md"
          color="indigo"
          checked={form.hasPassword}
          disabled={!settings.allowPasswords}
          aria-label="Paylaşım linkini şifreyle koru"
          onChange={(event) => {
            const enabled = event.currentTarget.checked;
            setForm((prev) => ({
              ...prev,
              hasPassword: enabled,
              ...(!enabled ? { password: '', passwordConfirm: '' } : {}),
            }));
          }}
        />
      </Group>
      {form.hasPassword && (
        <Stack gap="sm" mt="md">
          <PasswordInput
            label="Paylaşım şifresi"
            placeholder="En az 8 karakter"
            required
            value={form.password}
            onChange={(event) => update('password', event.currentTarget.value)}
            error={errors.password}
            autoComplete="new-password"
          />
          <PasswordInput
            label="Şifreyi tekrar girin"
            placeholder="Şifrenizi tekrar yazın"
            required
            value={form.passwordConfirm || ''}
            onChange={(event) => update('passwordConfirm', event.currentTarget.value)}
            error={errors.passwordConfirm}
            autoComplete="new-password"
          />
          <Text size="xs" c="dimmed">Link ve şifreyi mümkünse farklı kanallardan paylaşın. Şifre, bağlantı oluşturulduktan sonra tekrar görüntülenemez.</Text>
        </Stack>
      )}
      {!settings.allowPasswords && <Text size="xs" c="orange.8" mt="sm">Şifreyle paylaşım yönetici tarafından devre dışı bırakıldı.</Text>}
    </div>
    <NumberInput label="İndirme limiti (isteğe bağlı)" description="Boş bırakırsanız sınırsız olur." placeholder="Örn. 5" value={form.downloadLimit} onChange={(value) => update('downloadLimit', value)} min={1} max={99999} allowDecimal={false} allowNegative={false}/>
    <Alert variant="light" color="indigo" icon={<IconShieldCheck size={19}/>} title="Linkle paylaşım"><Text size="xs" lh={1.6}>E-posta adresi gerekmez. Linke sahip herkes, bağlantı aktifken dosyalara erişebilir. Hassas dosyalarda parola kullanmanızı öneriyoruz.</Text></Alert>
  </Stack>;
}
